<template>
  <table-layout>
    <template v-slot:title></template>
    <template v-slot:button></template>
    <template v-slot:table>
      <v-data-table
        height="65vh"
        :headers="getHeader(deleteOrgHeader)"
        :items="deletedOrgList"
        no-data-text="조회된 데이터가 없습니다"
        :items-per-page="-1"
        fixed-header
        mobile-breakpoint="md"
      >
        <template v-slot:item.stDt="{ value }">
          <div>{{ setDashDate(value) }}</div>
        </template>
        <template v-slot:item.edDt="{ value }">
          <div>{{ setDashDate(value) }}</div>
        </template>
        <template v-slot:item.restore="{ item }">
          <v-btn class="button" outlined @click="isRestoreOrg(item)">복구</v-btn>
        </template>
      </v-data-table>
    </template>
  </table-layout>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import {DELETE_ORG_LIST_TABLE} from "@/util/TableHeaders";
import TableMixin from "@/mixin/TableMixin";
import {mapGetters} from "vuex";
import {axiosInstance} from "@/util/AxiosModule";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "DeleteOrgList",
  components: {TableLayout},
  props: ["deleteTabs"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      deletedOrgList: [],
      deleteOrgHeader: DELETE_ORG_LIST_TABLE
    }
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"})
  },
  watch: {
    deleteTabs(value) {
      if (value === 0) {
        this.getDeleteOrgList();
      }
    }
  },
  methods: {
    async getDeleteOrgList() {
      try {
        const { data } = await axiosInstance.get("/private/org/deleted-org-list", {
          params: {
            orgCd: ""
          }
        });
        if (data.length < 1) {
          this.deletedOrgList = [];
          return false;
        } else {
          this.deletedOrgList = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    isRestoreOrg(orgData) {
      this.showConfirm({
        message: `${orgData.orgNm} 부서를 복구 하시겠습니까?`,
        successCallback: () => {
          this.restoreOrg(orgData);
        },
        failCallback: () => {
          return false;
        }
      });
    },
    async restoreOrg(orgData) {
      try {
        await axiosInstance.delete("/admin/org/org", {
          params: {
            memberId: this.memberId,
            orgCd: orgData.orgCd,
            useYn: "Y"
          }
        }).then(() => {
          this.showAlert({
            message: "부서 복구가 완료되었습니다",
            successCallback: () => {
              this.getDeleteOrgList();
              this.$emit("refresh");
            }
          })
        })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    }
  }
}
</script>